import { Store } from 'pullstate';
import { SocialUser } from '../global';
import { IResolveParams } from 'reactjs-social-login';

export interface IDesallStore {
  mobileMode: boolean;
  timeLeft: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  };
  socialUser?: SocialUser;
  socialResolve?: IResolveParams;
  portfolioDesignNames: string[]; //used for portfolio navigation...
}

const DesallStore = new Store<IDesallStore>({
  mobileMode: false,
  timeLeft: {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  },
  socialUser: undefined,
  portfolioDesignNames: [],
});

export default DesallStore;

export const setMobileMode = (value: boolean) => {
  DesallStore.update((s) => {
    s.mobileMode = value;
  });
};

export const clearSocialResolve = () => {
  DesallStore.update((s) => {
    s.socialResolve = undefined;
  });
};
export const setSocialResolve = (socialResolve: IResolveParams) => {
  console.log('setSocialResolve ', socialResolve.provider);
  DesallStore.update((s) => {
    s.socialResolve = socialResolve;
  });
};
export const setSocialUser = (socialUser: SocialUser) => {
  DesallStore.update((s) => {
    s.socialUser = socialUser;
  });
};

export const calculateTimeLeft = (targetSeconds: number) => {
  const now = new Date();
  const difference = targetSeconds - now.getTime() / 1000;
  if (difference < 0) {
    DesallStore.update((s) => {
      s.timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
    });
    return;
  }
  const days = Math.floor(difference / (60 * 60 * 24));
  const hours = Math.floor((difference / (60 * 60)) % 24);
  const minutes = Math.floor((difference / 60) % 60);
  const seconds = Math.floor(difference % 60);
  DesallStore.update((s) => {
    s.timeLeft = { days, hours, minutes, seconds };
  });
};

export const clearPortfolioNames = () => {
  DesallStore.update((s) => {
    s.portfolioDesignNames = [];
  });
};
export const setPortfolioNames = (names: string[]) => {
  DesallStore.update((s) => {
    s.portfolioDesignNames = names;
  });
};
